import { Organization } from '@models/Organization';
import styles from '@styles/components/Configuracion/Usuarios/ListadoPermisos.module.css';
import { PermissionRecord, Permissions, Role } from '@models/Permissions';
import { PeopleAltOutlined } from '@mui/icons-material';
import { NormalButton } from '@components/General/Button';
import { useState } from 'react';
import { QSwitch } from '@shared/designSystem/QSwitch';
import { set } from 'date-fns';
import { Application } from '@core/Application';
import { usePopup } from '@contexts/popupContext';
import ResultPopup from '@components/General/ResultPopup';

const ExpandablePermissionItem: React.FC<{
	name: string;
	permissionsList: Permissions.Id[];
	permissions: PermissionRecord[];
	onChangePerm: (permissionID: Permissions.Id, enabled: boolean) => void;
}> = ({ name, permissionsList, permissions, onChangePerm }) => {
	const [expanded, setExpanded] = useState(false);

	return (
		<div className={styles['permission-item']}>
			<div className={styles['permission-summary']} onClick={() => setExpanded(!expanded)}>
				<p>{name.localized()}</p>
				<div className={styles['expand-icon']}>{expanded ? '-' : '+'}</div>
			</div>
			{expanded &&
				permissionsList.map((permission) => (
					<div className={styles['permission-details']}>
						<p>{permission.localized()}</p>
						<QSwitch
							checked={permissions.some((p) => p.id === permission && p.effect === 'allow')}
							onChange={() => {
                                const isEnabled = permissions.some((p) => p.id === permission && p.effect === 'allow');
                                onChangePerm(permission, !isEnabled);
							}}
						/>
					</div>
				))}
		</div>
	);
};

const ListadoPermisos: React.FC<{ org: Organization; role: Role }> = ({ org, role }) => {
    const { showPopup } = usePopup();
        
	const [rolePerms, setRolePerms] = useState<PermissionRecord[]>(role.permissions);
    const [loading, setLoading] = useState(false);

    const onSaveChanges = async () => {
        const service = Application.shared().coreDependencies.rolesService;
        setLoading(true);
        try {
            await service.updateRolePermissions(org.id, role.id, rolePerms);
            showPopup(() => <ResultPopup result={"Permisos actualizados correctamente!".localized()} succesful={true} />);
        } catch (error) {
            console.log(error);
            showPopup(() => <ResultPopup result={"No se pudieron actualizar los permisos correctamente. Intentalo de nuevo.".localized()} succesful={false} />);
        } finally {
            setLoading(false);
        }
    }
                        

	return (
		<div className={styles.container}>
			<div className={styles.header}>
				<div>
					<PeopleAltOutlined style={{ color: '#98A2B3', fontSize: '32px' }} />
					<p className={styles.title}>Permisos</p>
				</div>
			</div>

			<div className={styles['permissions-list']}>
				{Object.keys(Permissions.ALL).map((permissionKey, index) => {
					return (
						<ExpandablePermissionItem
							key={index}
							name={permissionKey}
							permissionsList={Permissions.ALL[permissionKey]}
							permissions={rolePerms}
							onChangePerm={(permission, enabled) => {
								setRolePerms((prev) => {
									if (enabled) {
										// add permission
										return [...prev, {id: permission, effect: 'allow'}];
									} else {
										// remove permission
										return prev.filter(p => p.id !== permission);
									}
								});
							}}
						/>
					);
				})}
			</div>

			<div className={styles.footer}>
				<div className={styles.button}>
					<NormalButton
						text="Guardar cambios"
						onClick={onSaveChanges}
                        loading={loading}
					/>
				</div>
			</div>
		</div>
	);
};

export default ListadoPermisos;
